import { QuestionAssignmentDefinition, QuestionDefinition } from '../question';

import type { Nullable } from 'domain/Common';

export enum EventQuestionAssignmentType {
  PreEvent = 'PRE_EVENT',
  EndOfEvent = 'END_OF_EVENT',
  Room = 'ROOM',
  EndOfRoom = 'POST_NATTERING',
}

// topicId is null for a placement the Event does not link to a topic (legacy rows only).
export type EventQuestionAssignment = QuestionAssignmentDefinition<EventQuestionAssignmentType> & {
  topicId?: Nullable<number>;
};

export type EventQuestionDefinition = QuestionDefinition<EventQuestionAssignment> & {
  postNatteringQuestions?: PostNatteringQuestion[];
};

export type PostNatteringQuestion = QuestionDefinition<
  QuestionAssignmentDefinition<EventQuestionAssignmentType.EndOfRoom>
>;

// The topic id is the id of the question it was authored as, so it is what startNattering's `questionIds` carries.
export type EventTopic = {
  topicId: number;
  title: string;
  topicOrder: number;
  isObligatory: boolean;
  hasBeenDiscussed: boolean;
};
